module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.loadingCategories) ? _c('loader') : _vm._e(), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": _vm.$t('task.create.label')
    }
  }), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Ação"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Módulo",
      "columns": 6,
      "error": _vm.getError('module')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleSelected),
      expression: "moduleSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.toolBatchTaskModules), function(module) {
    return _c('option', {
      domProps: {
        "value": ((module.type) + "." + (module.identifier))
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(((module.type) + ".label"))) + " " + _vm._s(_vm.$t(((module.identifier) + ".label"))) + "\n            ")])
  })], 2)]), _vm._v(" "), (_vm.moduleSelected && _vm.toolBatchTaskActions.length) ? _c('form-group', {
    attrs: {
      "label": "Ação",
      "columns": 6,
      "error": _vm.getError('action')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionSelected),
      expression: "actionSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actionSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.toolBatchTaskActions), function(action) {
    return _c('option', {
      domProps: {
        "value": action.identifier
      }
    }, [_vm._v("\n              " + _vm._s(action.label) + "\n            ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sources.length && _vm.module.type === 'marketplace') ? _c('form-group', {
    attrs: {
      "label": "Fonte",
      "columns": 6,
      "error": _vm.getError('source'),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceSelected),
      expression: "sourceSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.sources), function(source) {
    return _c('option', {
      domProps: {
        "value": ((source.type) + "." + (source.identifier))
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(((source.type) + ".label"))) + " " + _vm._s(_vm.$t(((source.identifier) + ".label"))) + "\n            ")])
  })], 2)]) : _vm._e()], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Configurações"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Observação",
      "columns": 12
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-textarea",
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.actionSelected && _vm.action.hasOptions) ? _c('panel', {
    attrs: {
      "title": "Opções da ação"
    }
  }, [_c(_vm.actionOptionComponent, {
    ref: "actionOptionComponent",
    tag: "component",
    attrs: {
      "module": _vm.module
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actionSelected && _vm.action.hasModuleFilters) ? _c('panel', {
    attrs: {
      "title": ("Filtros do módulo (" + (_vm.$t(((_vm.module.type) + ".label"))) + " " + (_vm.$t(((_vm.module.identifier) + ".label"))) + ")")
    }
  }, [_c(_vm.actionModuleFilterComponent, {
    ref: "actionModuleFilterComponent",
    tag: "component",
    attrs: {
      "module": _vm.module
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showProductCodesFilter) ? _c('panel', {
    attrs: {
      "title": "Filtros de produto (Agrupador e SKU)"
    }
  }, [_c('product-codes', {
    ref: "productCodesFilterComponent"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.source && _vm.action.hasOptions && _vm.action.hasSourceFilters) ? _c('panel', {
    attrs: {
      "title": ("Filtros da fonte (" + (_vm.$t(((_vm.source.type) + ".label"))) + " " + (_vm.$t(((_vm.source.identifier) + ".label"))) + ")")
    }
  }, [_c(_vm.actionSourceFilterComponent, {
    ref: "actionSourceFilterComponent",
    tag: "component",
    attrs: {
      "source": _vm.source
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving || _vm.canNotSave
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.$t('task.create.label')))])]), _vm._v(" "), _c('modal-confirm', {
    on: {
      "option": function($event) {
        return _vm.save()
      }
    },
    model: {
      value: (_vm.showModalConfirm),
      callback: function($$v) {
        _vm.showModalConfirm = $$v
      },
      expression: "showModalConfirm"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7427e3a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Task/Create.vue
// module id = 3294
// module chunks = 0